import { atom } from '@reatom/framework'

import type { Address } from '@root/entities/address/Address'
import type { Network } from '@root/entities/network'

/** The wallet whose profile is open, or nothing. */
export const walletProfileModalAtom = atom<
  { walletAddress: Address; network: Network.Network } | undefined
>(undefined, 'walletProfileModalAtom')
